import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AdminState } from './admin.reducer';

export const selectAdminState = createFeatureSelector<AdminState>('admin');

export const selectDashboardStats = createSelector(
  selectAdminState,
  (state: AdminState) => state.dashboardStats,
);

export const selectConvertedFiles = createSelector(
  selectAdminState,
  (state: AdminState) => state.convertedFiles,
);

export const selectUsers = createSelector(
  selectAdminState,
  (state) => state.users,
);

export const selectUser = createSelector(
  selectAdminState,
  (state) => state.selectedUser,
);

export const selectUserStats = createSelector(
  selectAdminState,
  (state) => state.userStats,
);

export const selectCompanies = createSelector(
  selectAdminState,
  (state) => state.companies,
);

export const selectCompany = createSelector(
  selectAdminState,
  (state) => state.selectedCompany,
);

export const selectCompanyStats = createSelector(
  selectAdminState,
  (state) => state.companyStats,
);

export const selectCurrentBilling = createSelector(
  selectAdminState,
  (state) => state.billing,
);

export const selectCompanyBilling = createSelector(
  selectAdminState,
  (state) => state.selectedCompanyBilling,
);

export const selectDownloadingStatsCsv = createSelector(
  selectAdminState,
  (state: AdminState) => state.downloadingStatsCsv,
);

export const selectDownloadingCompanyStatsCsv = createSelector(
  selectDownloadingStatsCsv,
  (csv) => csv.companyStats,
);

export const selectDownloadingCompaniesStatsCsv = createSelector(
  selectDownloadingStatsCsv,
  (csv) => csv.companiesStats,
);

export const selectDownloadingCompanyStatsByIdCsv = (companyId: string) =>
  createSelector(
    selectDownloadingStatsCsv,
    (csv) => csv.companyStatsById[companyId] ?? false,
  );

export const selectDownloadingMonthlyBillingCsv = createSelector(
  selectAdminState,
  (state: AdminState) => state.downloadingMonthlyBillingCsv,
);

export const selectDownloadingCompaniesMonthlyBillingCsv = createSelector(
  selectDownloadingMonthlyBillingCsv,
  (billing) => billing.all,
);

export const selectDownloadingCompanyMonthlyBillingCsvById = (
  companyId: string,
) =>
  createSelector(
    selectDownloadingMonthlyBillingCsv,
    (billing) => billing.byCompany[companyId] ?? false,
  );

export const selectDashboardLoading = createSelector(
  selectAdminState,
  (state: AdminState) => state.loadingStats || state.loadingAdminStats,
);

export const selectDashboardReady = createSelector(
  selectAdminState,
  (state: AdminState) =>
    !state.loadingStats &&
    !state.loadingAdminStats &&
    state.dashboardStats !== null,
);
